import styles from "@/components/message-dialog.module.css";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { Dialog } from "@headlessui/react";
import { useSignalEffect } from "@preact/signals";
import clsx from "clsx";
import { t } from "i18next";
import { ChangeEvent, FormEvent, JSX, useId, useState } from "react";

function Prompt(): JSX.Element {
	const inputId = useId();

	const [inputValue, setInputValue] = useState<string>("");
	const [isClosing, setIsClosing] = useState<boolean>(false);

	const closePrompt = (): void => {
		globals.promptCallback = null;
		setInputValue("");
		setIsClosing(true);
		setTimeout(() => {
			signals.prompt.value = {};
			setIsClosing(false);
		}, 250);
	};

	const handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setInputValue(event.target.value);
	};

	const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
		event.preventDefault();
		void globals.promptCallback?.(inputValue);
		closePrompt();
	};

	useSignalEffect(() => {
		if (signals.prompt.value.defaultValue) {
			setInputValue(signals.prompt.value.defaultValue);
		}
	});

	return (
		<Dialog
			onClose={closePrompt}
			open={!!signals.prompt.value.label}
		>
			<div
				className={clsx(
					"overlay",
					"z-index", // above popup
					styles["dialog-overlay"],
					!isClosing && "zoom-in",
					isClosing && "zoom-out",
				)}
			>
				<form
					className={styles["dialog-container"]}
					onSubmit={handleSubmit}
				>
					<div className={styles["prompt-body"]}>
						<label htmlFor={inputId}>
							{signals.prompt.value.label}
						</label>
						<input
							autoComplete="off"
							className="input"
							data-autofocus
							id={inputId}
							inputMode={
								signals.prompt.value.type === "url"
									? "url"
									: undefined
							}
							type={signals.prompt.value.type || "text"}
							value={inputValue}
							onChange={handleInputChange}
						/>
					</div>
					<div className={styles["dialog-buttons"]}>
						<button
							className={styles["dialog-button"]}
							onClick={closePrompt}
							type="button"
						>
							{t("cancel")}
						</button>
						<button
							className={clsx(
								styles["dialog-button"],
								styles["default"],
							)}
							type="submit"
						>
							{t("confirmButton")}
						</button>
					</div>
				</form>
			</div>
		</Dialog>
	);
}

export default Prompt;
